import { render, staticRenderFns } from "./Detalhes.vue?vue&type=template&id=4280a41a"
import script from "./Detalhes.vue?vue&type=script&lang=js"
export * from "./Detalhes.vue?vue&type=script&lang=js"
import style0 from "./Detalhes.vue?vue&type=style&index=0&id=4280a41a&prod&lang=css"
import style1 from "./Detalhes.vue?vue&type=style&index=1&id=4280a41a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports